<!-- ----------------------------------------------- -->
<template>
  <v-sheet id="zc-content" :style="contentStyle">
    <!-- PCモード用(ツールチップ表示) -->
    <div v-if="isMode == 'pc'" class="com-map-menu pl-4">
      <v-row>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              depressed
              fab
              small
              class="mt-2"
              color="success"
              v-on="on"
              @click="incrementZoomLevel"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ text.tooltip_zoom_in }}</span>
        </v-tooltip>
      </v-row>
      <v-row>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div
              class="btn-scale-change mt-2"
              v-on="on"
              v-show="showSelectZoomBtn"
              @click="municipalities"
            >
              {{ text.municipalities }}
            </div>
          </template>
          <span>{{ text.tooltip_municipalities }}</span>
        </v-tooltip>
      </v-row>
      <v-row>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div
              class="btn-scale-change mt-2"
              v-on="on"
              v-show="showSelectZoomBtn"
              @click="prefectures"
            >
              {{ text.prefectures }}
            </div>
          </template>
          <span>{{ text.tooltip_prefectures }}</span>
        </v-tooltip>
      </v-row>
      <v-row>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div
              class="btn-scale-change mt-2"
              v-on="on"
              v-show="showSelectZoomBtn"
              @click="region"
            >
              {{ text.region }}
            </div>
          </template>
          <span>{{ text.tooltip_region }}</span>
        </v-tooltip>
      </v-row>
      <v-row>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div
              class="btn-scale-change mt-2"
              v-on="on"
              v-show="showSelectZoomBtn"
              @click="nationwide"
            >
              {{ text.nationwide }}
            </div>
          </template>
          <span>{{ text.tooltip_nationwide }}</span>
        </v-tooltip>
      </v-row>
      <v-row>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              depressed
              fab
              small
              class="mt-2"
              color="success"
              v-on="on"
              @click="decrementZoomLevel"
            >
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ text.tooltip_zoom_out }}</span>
        </v-tooltip>
      </v-row>
    </div>
    <!-- PCモード以外(ツールチップ非表示) -->
    <v-row v-else class="com-mb-map-menu" :isPc="!isPcMode && showToPc">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <!-- <v-row> -->
          <v-btn
            class="com-mb-map-menu-btn"
            :viewMode="showToPc ? 'pc' : 'mb'"
            :class="currentLocationBtnColor ? 'on-current-location' : ''"
            v-show="isMode == 'mb'"
            v-on="on"
            depressed
            icon
            @click="moveCurrentLocation()"
            aria-label="げんざいち"
          >
            <v-icon>$sideMenuHere</v-icon>
          </v-btn>
        </template>
        <span>{{ text.tooltip_here }}</span>
      </v-tooltip>
      <!-- </v-row> -->
      <!-- <v-row> -->
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            class="com-mb-map-menu-btn"
            :viewMode="showToPc ? 'pc' : 'mb'"
            v-on="on"
            depressed
            icon
            @click="incrementZoomLevel"
            aria-label="ちずのかくだい"
          >
            <v-icon>$sideMenuWide</v-icon>
          </v-btn>
        </template>
        <span>{{ text.tooltip_zoom_in }}</span>
      </v-tooltip>
      <!-- </v-row> -->
      <!-- <v-row> -->
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            class="com-mb-map-menu-btn menu-zoom-dec"
            :viewMode="showToPc ? 'pc' : 'mb'"
            v-on="on"
            depressed
            icon
            @click="decrementZoomLevel"
            aria-label="ちずのしゅくしょう"
          >
            <v-icon>$sideMenuNarrow</v-icon>
          </v-btn>
        </template>
        <span>{{ text.tooltip_zoom_out }}</span>
      </v-tooltip>
    </v-row>
    <!-- </div> -->
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 ズームコントロール
 * ZoomControl.vue
 * @author LIS
 */
import PageLog from "../../lib/pageLog.js";

export default {
  name: "map-zoom-control",
  /** データ部 */
  data: () => ({
    text: {
      nationwide: "全国",
      region: "地方",
      prefectures: "県",
      municipalities: "市",
      tooltip_nationwide: "全国",
      tooltip_region: "地方",
      tooltip_prefectures: "都道府県",
      tooltip_municipalities: "市町村",
      tooltip_zoom_out: "縮小",
      tooltip_zoom_in: "拡大",
      tooltip_here: "現在地",
    },
    /** ズームレベル指定ボタンの表示有無 */
    showSelectZoomBtn: false,
    /** PCモード切替ボタンの表示有無 */
    showToPc: true,
  }),
  mounted() {
    // 画面サイズ変更イベント
    window.addEventListener("resize", this.setShowSelectZoomBtn);
    this.setShowSelectZoomBtn();

    // 画面が縦長の場合、簡易版起動の場合はPCモード変更ボタンを非表示にする
    if (
      window.innerWidth < window.innerHeight ||
      global.KWB_MODE == "reduction"
    ) {
      this.showToPc = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setShowSelectZoomBtn);
  },
  /** 算出部 */
  computed: {
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** 緊急・任意お知らせの数を取得 */
    infoCount: {
      get() {
        let cnt = 0;
        if (this.$store.state.info.emergency) {
          cnt += this.$store.state.info.emergency.length;
        }
        if (this.$store.state.info.any) {
          cnt += this.$store.state.info.any.length;
        }
        return cnt;
      },
    },
    /** 表示位置調整 */
    contentStyle: {
      get() {
        // 地点登録モードの場合は位置固定
        if (this.$store.state.app.mode == "rp") {
          return "top: 0px;";
        }

        // お知らせ件数によって表示位置を調整する
        // お知らせの領域1つあたりの高さ
        const infoHeight = 30;
        // デフォルト位置
        let defaultTop = 76;
        if (!this.isPcMode) {
          defaultTop = 64;
        }
        // 表示位置調整値
        let offsetTop = 0;
        // 2件以内の場合は表示位置を調整しない
        if (this.infoCount > 2) {
          offsetTop = infoHeight * (this.infoCount - 2);
        }
        const topValue = defaultTop + offsetTop;
        return "top: " + String(topValue) + "px;";
      },
    },
    /** モード */
    isMode: {
      get() {
        return this.$store.state.app.mode;
      },
    },
    /** 現在位置取得ボタン色設定 */
    currentLocationBtnColor() {
      if (this.$store.state.map.currentLocationFlag) {
        return true;
      }
      return false;
    },
  },
  /** メソッド部 */
  methods: {
    /** ズームレベルを1段階下げる */
    decrementZoomLevel() {
      if (this.$store.state.map.zoom > this.$store.state.map.minZoom) {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.$store.state.map.zoom - 1,
          center: this.$store.state.map.center,
        });
      }
    },
    /** ズームレベルを1段階上げる */
    incrementZoomLevel() {
      if (this.$store.state.map.zoom < this.$store.state.map.maxZoom) {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.$store.state.map.zoom + 1,
          center: this.$store.state.map.center,
        });
      }
    },
    /** ズームレベルを全国にする */
    nationwide() {
      let zoom = this.mapConfig.zoomNationwide;
      if (this.isMode == "mb") {
        zoom = this.mapConfig.zoomNationwideMb;
      }
      this.$store.commit("inundation/setSelectedInundationParam", {
        inundationId: null,
        inundationNm: "非表示",
      });
      this.$store.commit("map/setMapInundation", {
        flg: false,
        inundationId: null,
      });
      setTimeout(() => {
        this.$store.commit("map/setMoveInfo", {
          zoom: zoom,
          center: this.$store.state.map.center,
        });
      }, 200);
    },
    /** ズームレベルを地方にする */
    region() {
      this.$store.commit("inundation/setSelectedInundationParam", {
        inundationId: null,
        inundationNm: "非表示",
      });
      this.$store.commit("map/setMapInundation", {
        flg: false,
        inundationId: null,
      });
      setTimeout(() => {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.mapConfig.zoomRegion,
          center: this.$store.state.map.center,
        });
      }, 200);
    },
    /** ズームレベルを都道府県にする */
    prefectures() {
      this.$store.commit("inundation/setSelectedInundationParam", {
        inundationId: null,
        inundationNm: "非表示",
      });
      this.$store.commit("map/setMapInundation", {
        flg: false,
        inundationId: null,
      });
      setTimeout(() => {
        this.$store.commit("map/setMoveInfo", {
          zoom: this.mapConfig.zoomPrefecture,
          center: this.$store.state.map.center,
        });
      }, 200);
    },
    /** ズームレベルを市町村にする */
    municipalities() {
      this.$store.commit("map/setMoveInfo", {
        zoom: this.mapConfig.zoomCity,
        center: this.$store.state.map.center,
      });
    },
    /** 現在位置取得ボタン押下 */
    moveCurrentLocation() {
      if (!this.$store.state.map.currentLocationFlag) {
        // アクセスログ出力
        PageLog.log({
          page_log: "gps",
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
      this.$store.dispatch("map/moveCurrentLocation", "mb");
    },
    /** ズームレベル指定のボタン群の表示制御 */
    setShowSelectZoomBtn() {
      // 画面サイズとお知らせ表示件数によって表示を切り替える
      // お知らせの領域1つあたりの高さ
      const infoHeight = 30;
      // ZoomControlの高さ+ヘッダーや設定ボタンなどの高さ
      let offsetHeight = 532;
      if (!this.isPcMode) {
        offsetHeight = 520;
      }
      // 表示位置調整値
      let offsetTop = 0;
      // 2件以内の場合は表示位置を調整しない
      if (this.infoCount > 2) {
        offsetTop = infoHeight * (this.infoCount - 2);
      }
      if (window.innerHeight < offsetHeight + offsetTop) {
        this.showSelectZoomBtn = false;
      } else {
        this.showSelectZoomBtn = true;
      }
    },
  },
  watch: {
    /** 緊急・任意お知らせの数 */
    infoCount() {
      this.setShowSelectZoomBtn();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/kwb.scss";
@import "./../../scss/color.scss";

#zc-content {
  position: absolute;
  z-index: 3025;
  left: 10px;
  background-color: transparent;
  // スケールチェンジボタン
  .btn-scale-change {
    width: 40px;
    height: 40px;
    font-size: 16px;
    background: $color-change-btn-back;
    border-color: $color-change-btn-border;
    border-style: solid;
    border-width: 1px;
    color: $color-change-btn-text;
    padding-top: 0.25em;
    border-radius: 50px;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
  }
}
</style>
